//import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'schedules-panel',
};

const useStyles = makeStyles(
  () => ({
    root: {},
    navBtn: {},
    activeNavBtn: {},
  }),
  options
);

export default useStyles;
